import { Subscription, SubscriptionStatus } from "../../models";

export function isSubscribed(sub: Subscription) {
    return [SubscriptionStatus.Active, SubscriptionStatus.Paused].includes(sub?.status);
}